import * as XLSX from 'xlsx';

export default class GlobalVar{ //Variaveis Globais

  static getLocalStorage(chave){
    let valor = localStorage.getItem(chave)
    return valor !== "undefined" && valor ? JSON.parse(valor) : null
  }

  static setLocalStorage(chave, valor){
    return localStorage.setItem(chave,JSON.stringify(valor));
  }

  static converteFloat = (valor, digitos = 2) => {
    return parseFloat(valor).toLocaleString('pt-BR', {minimumFractionDigits: digitos, maximumFractionDigits: digitos});
  }

  static desconverterFloat = (valor) => {
    var valorSemFormatacao = valor.replace('.', '').replace(',', '.');
    return parseFloat(valorSemFormatacao);
  }

  static exportaExcel (table, nomeArquivo) {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.table_to_sheet(table);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Planilha 1');

    // Salvar o arquivo
    XLSX.writeFile(workbook, `${nomeArquivo}.xlsx`);
  }

  static retornaMesAnterior = ()=>{
    let dataAnterior = new Date();
    dataAnterior = new Date(dataAnterior.getFullYear(), dataAnterior.getMonth(), 1)
    
    // Converte a data para uma string no formato ISO (YYYY-MM-DDTHH:mm:ss.sssZ)
    const dataAnteriorISO = dataAnterior.toISOString();

    // Extrai apenas a parte da data (YYYY-MM-DD)
    const dataAnteriorFormatada = dataAnteriorISO.split('T')[0];

    return dataAnteriorFormatada
  }

  static converterDataDMAH(dataISO) {
    let data = new Date(dataISO + ' UTC');
    let dia = data.getUTCDate();
    let mes = data.getUTCMonth() + 1; // Os meses começam do 0, então adicionamos 1.
    let ano = data.getUTCFullYear();
    let hora = data.getUTCHours();
    let minuto = data.getUTCMinutes();
    let segundo = data.getUTCSeconds();

    // Adiciona um zero à esquerda se o dia, mês, hora, minuto ou segundo for menor que 10.
    if(dia < 10) dia = '0' + dia;
    if(mes < 10) mes = '0' + mes;
    if(hora < 10) hora = '0' + hora;
    if(minuto < 10) minuto = '0' + minuto;
    if(segundo < 10) segundo = '0' + segundo;

    return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
}
}

